/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropType from 'prop-types'
import * as MaterialIcon from '@material-ui/icons'

const IconAdapter = ({
  iconName, color, children, ...props
}) => {
  const Icon = MaterialIcon[iconName]
  return (
    <Icon style={{ color }} {...props}>{ children }</Icon>
  )
}

IconAdapter.defaultProps = {
  children: null,
}

IconAdapter.propTypes = {
  children: PropType.node,
  color: PropType.string.isRequired,
  iconName: PropType.string.isRequired,
}

export default IconAdapter
